import { ApiPathComposer } from "../api/genPath";
import axiosClient from "./axiosClient";

class BlockDetailAPI {
  async getLinkOgs(url: string) {
    const response = await axiosClient.get<{ title: string }>(ApiPathComposer.API_BASE_PATH.OGS, {
      params: { url },
    });
    return response.data.title;
  }
}

const blockDetailAPI = new BlockDetailAPI();
export default blockDetailAPI;
